import React from "react";
import { Box } from "@mui/material";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import Flx from "../../../components/layout/Flx";
import colors from "../../../theme/colors";
import T from "../submissionTableTokens";
import { groupKindSummary, initialsOf } from "../submissionHelpers";

const ellipsis = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

/**
 * The borrower header above their submissions when grouping is on. Spans the
 * whole row (see the `colSpan` in submissionColumns) and carries the rollup that
 * the child rows can't: what they've sent, and how much of it is on a loan.
 *
 * Clicking collapses the group. It is NOT a master/detail row — `isRowMaster`
 * excludes group rows, so this chevron is the only thing it opens.
 */
const GroupHeaderCell = ({ data, onToggleGroup }) => {
  if (!data) return null;
  const { name, email, apps, auths, onLoans, total, __open: open } = data;

  return (
    <Flx
      centerY
      gap={1.375}
      onClick={() => onToggleGroup?.(data.key)}
      sx={{
        width: "100%",
        height: "100%",
        px: "4px",
        cursor: "pointer",
        userSelect: "none",
      }}
    >
      <ChevronRightRoundedIcon
        sx={{
          fontSize: 18,
          color: colors.slate400,
          flexShrink: 0,
          transform: open ? "rotate(90deg)" : "none",
          transition: "transform .2s",
        }}
      />
      <Flx
        centerX
        centerY
        sx={{
          width: 26,
          height: 26,
          borderRadius: "50%",
          flexShrink: 0,
          background: "linear-gradient(135deg,#1E3A66,#0F1E33)",
          color: "#fff",
          fontSize: 10,
          fontWeight: 600,
        }}
      >
        {initialsOf(name)}
      </Flx>

      <Flx centerY gap={1} sx={{ minWidth: 0 }}>
        <Box sx={{ fontSize: 13, fontWeight: 650, color: T.ink900, ...ellipsis }}>
          {name}
        </Box>
        {email && (
          <Box sx={{ fontSize: 12, color: T.ink500, ...ellipsis }}>{email}</Box>
        )}
      </Flx>

      <Box sx={{ flex: 1 }} />

      <Box sx={{ fontSize: 12, color: T.ink500, flexShrink: 0, pr: "12px" }}>
        <Box component="span" sx={{ color: T.ink900, fontWeight: 600 }}>
          {groupKindSummary({ apps, auths })}
        </Box>
        {` · ${onLoans} of ${total} on loans`}
      </Box>
    </Flx>
  );
};

export default GroupHeaderCell;
